import React, { useState, useEffect } from "react";
import { DropdownList } from "react-widgets";
import CKEditor5 from "../ckEditor5";
import PropTypes from "prop-types";
import { stripHtml } from "utils";

const TextField = (props) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <input
        className="form-control"
        autoComplete="off"
        {...props.formik.getFieldProps(...props.properties.name)}
        value={value}
        {...props.properties}
      />
      <div className="text-danger" style={{ display: props.formik.touched[props.properties.name] === true ? "block" : "none" }} role="alert">
        <small>{props.formik.touched[props.properties.name] === true ? props.formik.errors[props.properties.name] || "" : ""}</small>
      </div>
    </>
  );
};

// PropTypes for TextField
TextField.propTypes = {
  properties: PropTypes.object,
  formik: PropTypes.object,
};

const TextFieldInputGroup = (props) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <input
        className="form-control"
        autoComplete="off"
        {...props.formik.getFieldProps(...props.properties.name)}
        value={value}
        {...props.properties}
      />
    </>
  );
};

// PropTypes for TextFieldInputGroup
TextFieldInputGroup.propTypes = {
  properties: PropTypes.object,
  formik: PropTypes.object,
};

const CkEditor = (props) => {
  const [ProductInformation, setFormik] = useState(props.formik.values);
  const [content, setContent] = useState("");
  const onChange = (evt, editor) => {
    // evt.preventDefault()
    const newContent = editor.getData();
    setContent(newContent);
    let changedData = {};
    changedData[props.properties.name] = newContent;
    setFormik({ ...ProductInformation, ...changedData });
    props.formik.setFieldValue(props.properties.name, newContent, true);
  };

  useEffect(() => {
    let name = props.properties.name;
    setContent(props.formik.values[name] ? props.formik.values[name] : props.defaultContent ? props.defaultContent : "");
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <CKEditor5 content={content} onChange={onChange} editorHeight={props?.properties?.config?.height || props?.height || "600px"} />
      <div className="text-danger" style={{ display: props.formik.touched[props.properties.name] === true ? "block" : "none" }} role="alert">
        <small>{props.formik.touched[props.properties.name] === true ? props.formik.errors[props.properties.name] || "" : ""}</small>
      </div>
    </>
  );
};

// PropTypes for CkEditor
CkEditor.propTypes = {
  properties: PropTypes.object,
  formik: PropTypes.object,
  defaultContent: PropTypes.string,
  height: PropTypes.string,
};

const Dropdown = (props) => {
  const [value, setValue] = useState("");
  const [ProductInformation, setFormik] = useState(props.formik.values);

  const onChange = (val) => {
    let changedData = {};
    changedData[props.properties.name] = val;
    setFormik({ ...ProductInformation, ...changedData });
    props.formik.setFieldValue(props.properties.name, val, true);
    setValue(props.formik.values[props.properties.name]);
  };

  useEffect(() => {
    let name = props.properties.name;
    setValue(props.formik.values[name]);
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <DropdownList
        data={[...props.valueArr]}
        dropUp={true}
        formik={props.formik}
        onChange={onChange}
        {...props.properties}
        value={value ? value : props.properties.value}
      />
    </>
  );
};

// PropTypes for Dropdown
Dropdown.propTypes = {
  properties: PropTypes.object,
  formik: PropTypes.object,
  valueArr: PropTypes.array,
};

const CkEditorVideo = (props) => {
  const [ProductInformation, setFormik] = useState(props.formik.values);
  const [content, setContent] = useState("");
  const [contentLength, setContentLength] = useState(0);
  const { charCountLimit = 200 } = props.properties;

  const onChange = (evt, editor) => {
    // evt.preventDefault()
    const newContent = editor.getData();
    setContent(newContent);
    let changedData = {};
    changedData[props.properties.name] = newContent;
    setFormik({ ...ProductInformation, ...changedData });
    props.formik.setFieldValue(props.properties.name, newContent, true);

    const plainText = stripHtml(newContent);
    setContentLength(plainText.length);
  };

  useEffect(() => {
    let name = props.properties.name;
    setContent(props.formik.values[name] ? props.formik.values[name] : props.defaultContent ? props.defaultContent : "");
  }, [props.formik.values, props.properties.name]);

  return (
    <>
      <CKEditor5 content={content} onChange={onChange} editorHeight={props?.properties?.config?.height || props?.height || "600px"} />
      <span className="float-right">{`${contentLength}/${charCountLimit}`}</span>
      <div className="text-danger" style={{ display: props.formik.touched[props.properties.name] === true ? "block" : "none" }} role="alert">
        <small>{props.formik.touched[props.properties.name] === true ? props.formik.errors[props.properties.name] || "" : ""}</small>
      </div>
    </>
  );
};

// PropTypes for CkEditorVideo
CkEditorVideo.propTypes = {
  properties: PropTypes.object,
  formik: PropTypes.object,
  defaultContent: PropTypes.string,
  height: PropTypes.string,
};

export { TextField, Dropdown, CkEditor, TextFieldInputGroup, CkEditorVideo };
